import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontFredoka, transientOptions } from "@product/scmp-sdk";

import { BaseEntityLink } from "~/components/base-entity-link";

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;

  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontFredoka};

  ${props => props.theme.breakpoints.up("tablet")} {
    flex: 1;
    grid-template-columns: repeat(3, 135px);
    gap: 0;
    justify-content: space-between;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid-template-columns: repeat(3, 155px);
    justify-content: flex-start;

    font-size: 16px;
    column-gap: 48px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    column-gap: 76px;
  }
`;

export const MenuItem = styled.div``;

export const MenuTitle = styled.div`
  margin-block-end: 16px;

  color: #ffffff;
  font-weight: 600;
`;

type MenuItemBaseLinkProps = {
  $isBold?: boolean;
  $isLargeSpacing?: boolean;
};
export const MenuItemBaseLink = styled(BaseEntityLink, {
  ...transientOptions,
})<MenuItemBaseLinkProps>(
  props => css`
    display: table;

    color: #ffffff;

    &:not(:last-child) {
      margin-block-end: 10px;
    }

    ${props.$isBold &&
    css`
      font-weight: 600;
    `}

    ${props.$isLargeSpacing &&
    css`
      &:not(:last-child) {
        margin-block-end: 16px;
      }
    `}
  `,
);
